import { scrollToId } from "@/lib/lenis";
import { LogoMark } from "@/components/Logo";

const COLS = [
  {
    title: "Products",
    links: [
      { label: "Solar Panels", id: "products" },
      { label: "Inverters & Batteries", id: "products" },
      { label: "Rooftop Systems", id: "products" },
      { label: "Water Heaters & Lights", id: "products" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Panel Designer", id: "designer" },
      { label: "Why Us", id: "why" },
      { label: "Installation Process", id: "process" },
      { label: "Savings Calculator", id: "savings" },
      { label: "Get a Quote", id: "quote" },
    ],
  },
];

export const Footer = () => (
  <footer id="contact" className="relative overflow-hidden border-t border-gold/15 bg-ink pt-20 pb-10">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <LogoMark className="h-11 w-11" />
            <div className="leading-none">
              <p className="font-display text-lg font-bold text-warm">Maa Sakumbri</p>
              <p className="mt-1.5 font-mono text-[9px] tracking-[0.42em] text-gold">SOLAR</p>
            </div>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-mutegray">
            Architectural solar energy for modern Indian homes and enterprises. Premium products,
            in-house installation and lifetime care — powered by the sun, perfected by us.
          </p>
          <a
            href="https://maasakumbrisolar.com"
            className="mt-6 inline-block font-mono text-xs tracking-[0.2em] text-gold hover:text-goldlight transition-colors"
            data-testid="footer-domain-link"
          >
            MAASAKUMBRISOLAR.COM
          </a>
        </div>

        {COLS.map((c) => (
          <div key={c.title} className="lg:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-gold">{c.title}</p>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l.label}>
                  <button
                    type="button"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-mutegray transition-colors duration-300 hover:text-warm"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-gold">Reach us</p>
          <ul className="mt-5 space-y-3 text-sm text-mutegray">
            <li>
              <a href="tel:+917983217276" data-testid="footer-phone-link" className="transition-colors duration-300 hover:text-warm">+91 79832 17276</a>
            </li>
            <li>
              <a href="mailto:anuragsingh@maasakumbrisolar.com" data-testid="footer-email-link" className="break-all transition-colors duration-300 hover:text-warm">anuragsingh@maasakumbrisolar.com</a>
            </li>
            <li>
              Maa Sakumbri Solar,<br />
              Rajpur Chhajpur, Tehsil Budhana,<br />
              Distt. Muzaffarnagar — 247775
            </li>
          </ul>
        </div>
      </div>

      <p
        aria-hidden="true"
        className="pointer-events-none mt-20 select-none text-center font-display text-[13vw] lg:text-[9.5vw] font-extrabold leading-none tracking-tight text-transparent"
        style={{ WebkitTextStroke: "1px rgba(245,158,11,0.14)" }}
      >
        MAASAKUMBRI
      </p>

      <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-8 sm:flex-row">
        <p className="text-xs text-mutegray">© 2025 Maa Sakumbri Solar · All rights reserved</p>
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-gold/70">
          Made with sunlight
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
